<template>
  <v-row>
    <v-col class="ma-0" cols="7">
      <p>
        <fin-lexicon-text
          auto-solve
          text="Entwickle dich nach und nach vom Newbie zum Semi-Pro. Tauche ein in die spannende Welt der Kapitalmärkte. Basiswissen, hilfreiche Tutorials und mehr..."/>
      </p>
    </v-col>
    <v-col align="right" cols="5">
      <v-img :max-width="275"
             :src="require('@/assets/academy/academy.svg')"
             :style="'z-index: 30;' + ($vuetify.breakpoint.sm ? 'margin-top: -70px;' : $vuetify.breakpoint.mdAndUp ? 'margin-top: -80px;' : '')"
             class="img"
             contain/>
    </v-col>
  </v-row>
</template>


<script>
import FinLexiconText from "@/components/common/lexicon/LexiconText"

export default {
  name: "FinAcademyIntro",
  components: {FinLexiconText}
}
</script>

<style lang="scss" scoped>

</style>
